import React, { Component } from 'react';
import styles from './CustomTextFieldWithCloseIcon.css';

const debug = _debug('app:CustomTextFieldWithCloseIcon');
class CustomTextFieldWithCloseIcon extends Component {

  static propTypes = {
    value: React.PropTypes.string,
    changeEvent: React.PropTypes.func,
    placeholder: React.PropTypes.string,
    className: React.PropTypes.arrayOf(React.PropTypes.shape({})),
    name: React.PropTypes.string
  };

  constructor(props) {
    super(props);
    debug(props);
  }

  render() {
    return (
      <div className={styles.mainContainer}>
        <input
          type="text"
          name={this.props.name}
          placeholder={this.props.placeholder}
          className={this.props.className}
          value={this.props.value}
          onChange={this.props.changeEvent}
          onClick={e => e.stopPropagation()}
          onKeyDown={e => e.stopPropagation()}
          onKeyUp={e => e.stopPropagation()}
        />
        {this.props.value &&
          <button className={styles.clearIcon} onClick={this.props.changeEvent}>&times;</button>
        }
      </div>
    );
  }
}
export default CustomTextFieldWithCloseIcon;



// WEBPACK FOOTER //
// ./src/components/CustomTextFieldWithCloseIcon/CustomTextFieldWithCloseIcon.js